// extracted by mini-css-extract-plugin
export var bestFor = "w_bt";
export var ctaButton = "w_bs";
export var icons = "w_br";
export var mainHeadRow = "w_bp";
export var secondaryHeadRow = "w_bq";
export var tableContainer = "w_bn";